import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  CardContainer,
  CardHeading,
  CardTitle,
  CustomDropdownItemV1,
  CustomMenuV1,
  CustomToggleV1,
  FilterIconConatainer,
  LeftSection,
} from "./styles";
import RecognitionCommonCard from "./RecognitionCommonCard";
import {
  ExploringYourImpactIcon,
  FilterIcon,
  TeamAnalyticsIcon,
} from "../../utils/icons";
import {
  GetMostPraisedMembersDetails,
  GetFrequentRecognitionGiverDetails,
  GetLeadingSupporterDetails,
  GetTopAcknowledgmentsDetails,
} from "../../redux/constants/apiConstants";
import { fetchApi, getStartAndEndDates } from "../../utils/methods";
import { toast } from "react-toastify";
import { Dropdown } from "react-bootstrap";
import RecognitionPopup from "./Dashboard/RecognitionPopup";
import ReportPopup from "./Dashboard/ReportPopup";

function RecognitionCardContainer() {
  const [praisedMembersData, setPraisedMembersData] = useState([]);
  const [recognitionGiverData, setRecognitionGiverData] = useState([]);
  const [leadingSupportedData, setLeadingSupportedData] = useState([]);
  const [topAcknowledgmentsData, setTopAcknowledgmentsData] = useState([]);
  const [timeInterval, setTimeInterval] = useState("Monthly");
  const [exploringTimeInterval, setExploringTimeInterval] = useState("Monthly");
  const [showRecognitionPopUp, setShowRecognitionPopUp] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [selectedCard, setSelectedCard] = useState({ title: "", type: "" });
  const [showReportPopUp, setShowReportPopUp] = useState(false);
  const location = useLocation();
  const isDashboardRoute = location.pathname.includes("dashboard");


  useEffect(() => {
    fetchMostPraisedMembersData();
    fetchFrequentRecognitionGiverData();
    fetchLeadingSupporterData();
    fetchTopAcknowledgmentsData();
  }, [timeInterval]);

  useEffect(() => {
    fetchLeadingSupporterData();
    fetchTopAcknowledgmentsData();
  }, [exploringTimeInterval]);

  const handleSelect = (eventKey) => {
    setTimeInterval(eventKey);
  };

  const exploreHandleSelect = (eventKey) => {
    setExploringTimeInterval(eventKey);
  };

  const fetchMostPraisedMembersData = async () => {
    const { startDate, endDate } = getStartAndEndDates(timeInterval);
    const apiUrl = `${GetMostPraisedMembersDetails}/${startDate}/${endDate}`;

    try {
      const res = await fetchApi(apiUrl, "GET");
      if (res.status === "success") {
        setPraisedMembersData(res.data);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      window.console.error(error);
    }
  };

  const fetchFrequentRecognitionGiverData = async () => {
    const { startDate, endDate } = getStartAndEndDates(timeInterval);
    const apiUrl = `${GetFrequentRecognitionGiverDetails}/${startDate}/${endDate}`;

    try {
      const res = await fetchApi(apiUrl, "GET");
      if (res.status === "success") {
        setRecognitionGiverData(res.data);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      window.console.error(error);
    }
  };

  const fetchLeadingSupporterData = async () => {
    const { startDate, endDate } = getStartAndEndDates(exploringTimeInterval);
    const apiUrl = `${GetLeadingSupporterDetails}/${startDate}/${endDate}`;

    try {
      const res = await fetchApi(apiUrl, "GET");
      if (res.status === "success") {
        setLeadingSupportedData(res.data);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      window.console.error(error);
    }
  };

  const fetchTopAcknowledgmentsData = async () => {
    const { startDate, endDate } = getStartAndEndDates(exploringTimeInterval);
    const apiUrl = `${GetTopAcknowledgmentsDetails}/${startDate}/${endDate}`;
    try {
      const res = await fetchApi(apiUrl, "GET");
      if (res.status === "success") {
        setTopAcknowledgmentsData(res.data);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      window.console.error(error);
    }
  };

  return (
    <>
      <CardContainer id="recognition-card" isMargin={isDashboardRoute ? "40px" : " 4px"}>
        <CardHeading id="recognition-heading">
          <LeftSection id="recognition-left-section">
            <div>{TeamAnalyticsIcon()}</div>
            <CardTitle id="recognition-title">Team Analytics</CardTitle>
          </LeftSection>
          <FilterIconConatainer id="recognition-filter">
            <Dropdown  id="recognition-dropdown" onSelect={handleSelect} style={{ cursor: "pointer" }}>
              {isDashboardRoute ? (
                <CustomToggleV1 id="dropdown-custom-components">
                  <div className="filter-icon"> {FilterIcon()}</div>
                </CustomToggleV1>
              ) : null}
              <CustomMenuV1 id="recognition-dropdown-menu" align="end">
                {["Monthly", "Quarterly", "Yearly"].map((interval) => (
                  <CustomDropdownItemV1
                    id="recognition-menu-item"
                    key={interval}
                    eventKey={interval}
                    active={timeInterval === interval}
                  >
                    {interval}
                  </CustomDropdownItemV1>
                ))}
              </CustomMenuV1>
            </Dropdown>
          </FilterIconConatainer>
        </CardHeading>
        <div style={{ display: "flex", rowDirection: "column", gap: "20px" }}>
          <RecognitionCommonCard
            title={"Most Praised Team Members"}
            data={praisedMembersData}
            lastColumnName={"Recognition Received"}
            setSelectedMember={setSelectedMember}
            setSelectedCard={setSelectedCard}
            setShowRecognitionPopUp={setShowRecognitionPopUp}
            cardType={{ type: 1, subtype: 1 }}
            setShowReportPopUp={setShowReportPopUp}
          />
          <RecognitionCommonCard
            title={"Frequent Recognition Giver"}
            data={recognitionGiverData}
            lastColumnName={"Recognition Given"}
            setSelectedMember={setSelectedMember}
            setSelectedCard={setSelectedCard}
            setShowRecognitionPopUp={setShowRecognitionPopUp}
            cardType={{ type: 1, subtype: 2 }}
            setShowReportPopUp={setShowReportPopUp}
          />
        </div>
      </CardContainer>

      <CardContainer id="recognition-card-2" isMargin={"20px"} style={{ marginBottom: "95px" }}>
        <CardHeading id="recognition-heading-2">
          <LeftSection id="recognition-left-section-2">
            <div>{ExploringYourImpactIcon()}</div>
            <CardTitle id="recognition-title-2">Exploring Your Impact</CardTitle>
          </LeftSection>
          <FilterIconConatainer id="recognition-filter-2">
            <Dropdown
              id="recognition-dropdown-2"
              onSelect={exploreHandleSelect}
              style={{ cursor: "pointer" }}
            >
              {isDashboardRoute ? (
                <CustomToggleV1 id="dropdown-custom-components">
                  <div className="filter-icon"> {FilterIcon()}</div>
                </CustomToggleV1>
              ) : null}
              <CustomMenuV1 id="recognition-dropdown-menu-2" align="end">
                {["Monthly", "Quarterly", "Yearly"].map((interval) => (
                  <CustomDropdownItemV1
                    id="recognition-dropdown-item-2"
                    key={interval}
                    eventKey={interval}
                    active={timeInterval === interval}
                  >
                    {interval}
                  </CustomDropdownItemV1>
                ))}
              </CustomMenuV1>
            </Dropdown>
          </FilterIconConatainer>
        </CardHeading>
        <div style={{ display: "flex", rowDirection: "column", gap: "20px" }}>
          <RecognitionCommonCard
            title={"Your Leading Supporter"}
            data={leadingSupportedData}
            lastColumnName={"Recognition Received"}
            setSelectedMember={setSelectedMember}
            setSelectedCard={setSelectedCard}
            setShowRecognitionPopUp={setShowRecognitionPopUp}
            cardType={{ type: 2, subtype: 1 }}
            setShowReportPopUp={setShowReportPopUp}
          />
          <RecognitionCommonCard
            title={"Your Top Acknowledgments "}
            data={topAcknowledgmentsData}
            lastColumnName={"Recognition Given"}
            setSelectedMember={setSelectedMember}
            setSelectedCard={setSelectedCard}
            setShowRecognitionPopUp={setShowRecognitionPopUp}
            cardType={{ type: 2, subtype: 2 }}
            setShowReportPopUp={setShowReportPopUp}
          />
        </div>
      </CardContainer>

      {showRecognitionPopUp && (
        <RecognitionPopup
          member={selectedMember}
          showModal={showRecognitionPopUp}
          headerText={selectedCard.title}
          onClose={() => setShowRecognitionPopUp(false)}
          timeInterval={
            selectedCard.type === 1
              ? timeInterval
              : selectedCard.type === 2
                ? exploringTimeInterval
                : null
          }
          selectedCard={selectedCard}
        />
      )}
      {showReportPopUp && (
        <ReportPopup
          member={selectedMember}
          showModal={showReportPopUp}
          headerText={selectedCard.title}
          onClose={() => setShowReportPopUp(false)}
          timeInterval={
            selectedCard.type === 1
              ? timeInterval
              : selectedCard.type === 2
                ? exploringTimeInterval
                : null
          }
          selectedCard={selectedCard}
        />
      )}
    </>
  );
}

export default RecognitionCardContainer;
